import { Component } from '@angular/core';
import { ConfiguratorService } from 'src/app/shared/services/configurator-service/configurator.service';

@Component({
  selector: 'app-login-screen',
  templateUrl: './login-screen.component.html',
  styleUrls: ['./login-screen.component.css']
})
export class LoginScreenComponent {

  headerLogo = '../../assets/image/logo.png';
  supportContactEmail = 'support@sigmat.in';
  supportContactNumber = '+91 8878857588';

  constructor(private configuratorService: ConfiguratorService) {}

  ngOnInit() {
    this.headerLogo = '../../assets/image/logo.png';
  }

  get supportPhoneHref(): string {
    return 'tel:' + String(this.supportContactNumber || '').replace(/\s+/g, '');
  }

  getThemeData() {
    this.configuratorService.getAppConfigurationDetail().subscribe((data: any) => {
      const themeConfig: any = data.data;
      this.supportContactEmail = themeConfig?.supportContactEmail ?? 'support@sigmat.in';
      this.supportContactNumber = themeConfig?.supportContactNumber ?? '+91 4442624172';
      this.headerLogo = themeConfig?.headerLogo ?? '../assets/image/logo.png';
    });
  }

  loadCalendly(): void {
    window.open('https://calendly.com/sigmat/meeting-with-sigmat', '_blank', 'noopener');
  }
}
